// Derive a character's ARKit gather from its bundle's rig_names.json.
//
// A splat character's live lip-sync path is ARKit-52 → arkitToMh (188 MetaHuman
// controls, ./arkitToMh.js) → gather the N controls the character's decoders
// were trained on. Which N controls — and their order — is declared by the
// bundle's own rig_names.json (isaac V1: 60, isaac V2 head+teeth: 174), so the
// gather is derived from the bundle at load time instead of being a hardcoded
// per-character build artifact. A control space the 188 ordering can't express
// throws (loud, per CLAUDE.md UX rules) — the caller reports "no lip-sync"
// rather than decoding garbage.

import { MH_RIG_NAMES } from './rigNamesMh.js'

let _indexOfName = null
function indexOfName() {
  if (!_indexOfName) _indexOfName = new Map(MH_RIG_NAMES.map((n, i) => [n, i]))
  return _indexOfName
}

/**
 * @param {string[]} rigNames - the bundle's rig_names.json (N control names)
 * @returns {number[]} N indices into the 188-control arkitToMh output
 * @throws when rigNames is not a non-empty string array, or any name is
 *         missing from the canonical 188 ordering
 */
export function gatherFromRigNames(rigNames) {
  if (!Array.isArray(rigNames) || rigNames.length === 0) {
    throw new Error('rig_names.json is not a non-empty array')
  }
  const idx = indexOfName()
  const missing = []
  const gather = rigNames.map((name) => {
    const i = idx.get(name)
    if (i === undefined) missing.push(name)
    return i
  })
  if (missing.length) {
    const shown = missing.slice(0, 5).join(', ')
    throw new Error(
      `rig_names.json has ${missing.length} control(s) not in the 188 MH ordering: ${shown}${missing.length > 5 ? ', …' : ''}`,
    )
  }
  return gather
}
